"use client";

import SpecialProductCard from "./special-product-card";

interface ProductVariant {
  id: string;
  option: string;
  priceRec: number;
  specialPriceRec?: number;
}

interface Product {
  id: string;
  name: string;
  brand?: { name: string };
  category: string;
  image?: string;
  variants: ProductVariant[];
}

interface SpecialsProductGridProps {
  products: Product[];
  maxItems?: number;
  showViewAll?: boolean;
  specialId?: string;
  totalCount?: number;
}

export default function SpecialsProductGrid({ 
  products, 
  maxItems = 6,
  showViewAll = true,
  specialId,
  totalCount
}: SpecialsProductGridProps) {
  const displayProducts = products.slice(0, maxItems);
  const remaining = (totalCount || products.length) - maxItems;

  return (
    <div className="p-3 sm:p-4">
      {/* Responsive grid - 2 cols on mobile, scales up */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2 sm:gap-3">
        {displayProducts.map((product) => (
          <SpecialProductCard key={product.id} product={product} />
        ))}
      </div>
      
      {/* View All Link */}
      {showViewAll && remaining > 0 && specialId && (
        <a 
          href={`/specials/${specialId}`}
          className="mt-4 block text-center text-sm text-primary_green hover:underline font-medium"
        >
          View all {totalCount || products.length} eligible items →
        </a>
      )}
    </div>
  );
}
